import { motion } from "framer-motion";

const cardVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: (index: number) => ({
    opacity: 1,
    y: 0,
    transition: { delay: index * 0.1, duration: 0.6 },
  }),
};

type Sector = {
  name: string;
  outcome: string;
  image: string;
};

type SectorsSectionProps = {
  sectors: Sector[];
};

export function SectorsSection({ sectors }: SectorsSectionProps) {
  return (
    <section className="bg-slate-950/95 py-24" aria-labelledby="sectors-heading">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-3xl">
            <h2
              id="sectors-heading"
              className="text-3xl font-semibold text-white sm:text-4xl"
            >
              Sectors served
            </h2>
            <p className="mt-4 text-slate-300">
              We design for teams operating under pressure—translating complexity into clarity across domains.
            </p>
          </div>
        </div>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          className="mt-12 grid gap-6 sm:grid-cols-2"
        >
          {sectors.map((sector, index) => (
            <motion.article
              key={sector.name}
              custom={index}
              variants={cardVariants}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 shadow-lg"
            >
              <img
                src={sector.image}
                alt={`${sector.name} outcomes`}
                className="h-56 w-full object-cover transition duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/40 to-transparent" />
              <div className="relative flex min-h-52 flex-col justify-end gap-3 px-8 pb-8">
                <h3 className="text-xl font-semibold text-white">{sector.name}</h3>
                <p className="text-sm text-slate-200">{sector.outcome}</p>
                <a
                  href="#sectors"
                  className="inline-flex items-center text-xs font-semibold uppercase tracking-[0.3em] text-emerald-300 hover:text-emerald-200"
                >
                  EXPLORE SECTOR
                </a>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
